import { useEffect, useState } from 'react'

import { UpdateZone, GetActiveStadiumZones, GetGenderMode, SaveUserZone, ValidateNumberZone } from './../../utilities/BL/Zones'


const Zones = ({ onZoneSaved, roomId }) => {
    const [selectedZone, setSelectedZone] = useState(0)
    const [errorMessage, setErrorMessage] = useState('')
    const [disabledButton, setDisabledButton] = useState(true)

    const [womensModeActive,setWomensModeActive] = useState(false)
    const [isWorking,setIsWorking] = useState(false)
    
    // NUEVO ESTADO PARA ZONAS DINÁMICAS
    const [dynamicZones, setDynamicZones] = useState([])

    // const ChangeListValue = async (e) => {
    //     try {
    //         setErrorMessage('')
    //         setSelectedZone(0)
            
    //         const option = parseInt(e.target.value)
            
    //         if (option >= 1 && option <= 11) {
    //             setDisabledButton(false)
    //             setSelectedZone(option)
    //         } else {
    //             setDisabledButton(true)
    //         }
    //     } catch (error) {
            
    //     }
    // }

    const ChangeListValue = async (e) => {
        setErrorMessage('')
        setSelectedZone(0)
        const option = parseInt(e.target.value)
        if (option > 0) {
            setDisabledButton(false)
            setSelectedZone(option)
        } else {
            setDisabledButton(true)
        }
    }

    // const SaveZone = async () => {
    //     try {
    //         setIsWorking(true)
    //         setErrorMessage('')
            
    //         if (selectedZone === 0) {
    //             setErrorMessage('Selecciona tu zona')
    //             return
    //         }

    //         // Validar id de zona elegida y obtener el nombre de la zona
    //         const responseValidate = await ValidateNumberZone(selectedZone)
    //         if (responseValidate.success) {

    //             const response = await SaveUserZone(responseValidate.data.text)
    //             if (!response.success) {
    //                 setErrorMessage(response.message)
    //                 return
    //             }

    //             // 2. Conectar WebSocket con la zona
    //             await ConnectWebSocket(response.data.text)

    //             // 3. Cambiar a vista Sections
    //             onZoneSaved()
    //         } else {
    //             setErrorMessage(responseValidate.message)
    //         }
    //     } catch (error) {
    //         console.error('SaveZone - Zones', error)
    //         setErrorMessage('Ocurrió un error al guardar la zona o conectar WebSocket')
    //     } finally {
    //         setIsWorking(false)
    //     }
    // }

    const SaveZone = async () => {
        try {
            setIsWorking(true)
            setErrorMessage('')
            if (selectedZone === 0) return setErrorMessage('Selecciona tu zona')

            // Buscamos la zona seleccionada en nuestra lista dinámica
            const selectedZoneData = dynamicZones.find(z => z.id === selectedZone);
            if (!selectedZoneData) return setErrorMessage('Zona no válida');

            // Guardamos usando el nombre "real/interno" que el backend espera (Ej. "azul")
            const response = await SaveUserZone(selectedZoneData.internalName)
            if (!response.success) return setErrorMessage(response.message)

            await UpdateZone(response.data.text, roomId)
            onZoneSaved()
        } catch (error) {
            setErrorMessage('Ocurrió un error al guardar la zona')
        } finally {
            setIsWorking(false)
        }
    }

    // const LoadPage = async () => {
    //     try {
    //         // Borrar clases de temas de colores
    //         const classList = [
    //             "Colors--1--Primary",
    //             "Colors--1--Secondary",
    //             "Colors--2--Primary",
    //             "Colors--2--Secondary",
    //             "Colors--3--Primary",
    //             "Colors--4--Primary",
    //             "Colors--4--Secondary",
    //             "Colors--5--Primary",
    //             "Colors--5--Secondary",
    //             "Quiz__Background__Femenil--Blue",
    //             "Quiz__Background__Femenil--Golden"
    //         ]


    //         classList.forEach(item => {
    //             document.body.classList.remove(item)
    //             document.getElementById("fdmFooter")?.classList.remove(item)
    //         })

            
    //         // Revisar si está activo el modo femenil para estableecerlo
    //         const responseWomensModeActive = await GetGenderMode()
    //         if (responseWomensModeActive.success && responseWomensModeActive.data.isWomensModeActive) {
    //             setWomensModeActive(true)
    //         }
    //     } catch (error) {
            
    //     }
    // }

    const LoadPage = async () => {
        try {
            // Borrar clases de temas de colores
            // const classList = [
            //     "Colors--1--Primary",
            //     "Colors--1--Secondary",
            //     "Colors--2--Primary",
            //     "Colors--2--Secondary",
            //     "Colors--3--Primary",
            //     "Colors--4--Primary",
            //     "Colors--4--Secondary",
            //     "Colors--5--Primary",
            //     "Colors--5--Secondary",
            //     "Quiz__Background__Femenil--Blue",
            //     "Quiz__Background__Femenil--Golden"
            // ]


            // classList.forEach(item => {
            //     document.body.classList.remove(item)
            //     document.getElementById("fdmFooter")?.classList.remove(item)
            // })

            
            // Revisar si está activo el modo femenil para estableecerlo
            // const responseWomensModeActive = await GetGenderMode()
            // if (responseWomensModeActive.success && responseWomensModeActive.data.isWomensModeActive) {
            //     setWomensModeActive(true)
            // }

            // NUEVO: Consultar al servidor las zonas activas
            const zonesRes = await GetActiveStadiumZones(roomId);
            if (zonesRes.success && zonesRes.data.length > 0) {
                setDynamicZones(zonesRes.data);
            } else {
                // FALLBACK: Si falla el servidor, pones tus zonas de emergencia aquí
                setDynamicZones([
                    { id: 1, displayName: "Zona 1", internalName: "zona1" },
                    { id: 2, displayName: "Platea Zona 1", internalName: "zona2" },
                    { id: 3, displayName: "Palcos Zona 1", internalName: "zona3" },
                    { id: 4, displayName: "Cabecera Norte", internalName: "zona4" },
                    { id: 5, displayName: "Cabecera Sur", internalName: "zona5" },
                    { id: 6, displayName: "Zona 2", internalName: "zona6" },
                    { id: 7, displayName: "Platea Zona 2", internalName: "zona7" },
                    { id: 8, displayName: "Palcos Zona 2", internalName: "zona8" }
                ]);
                // PARA PRODUCCIÓN (2 ZONAS ORIGINALES):
                // setDynamicZones([
                //     { id: 1, displayName: "Xolo Mayor Rojo", internalName: "zona1" },
                //     { id: 2, displayName: "Xolo Mayor Blanco", internalName: "zona2" }
                // ]);
            }
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    }, [roomId])


    return (
        <div className="Zones">
            <div className="Zones__ListContainer">
                <label className="Zones__ListContainer__Label" htmlFor="sZone">Selecciona tu zona:</label>
                <select id="sZone" className="Zones__ListContainer__List" name="zone" value={selectedZone} onChange={(e) => ChangeListValue(e)}>
                    <option value={0}>Selecciona una zona</option>
                    
                    {/* RENDERIZADO DINÁMICO */}
                    {dynamicZones.map(zone => (
                        <option key={zone.id} value={zone.id}>
                            {zone.displayName}
                        </option>
                    ))}
                </select>

                {disabledButton ? (
                    <p className="Btn__Adsl--Disabled Zones__ListContainer__Button">Guardar</p>
                ) : (
                    isWorking ? (
                        <button className="Btn__Adsl--Disabled Zones__ListContainer__Button">Guardando...</button>
                    ) : (
                        <>
                            <button className="Btn__Adsl--Red Zones__ListContainer__Button" onClick={SaveZone}>Guardar</button>
                            {errorMessage && <p className="Zones__ListContainer__Error">{errorMessage}</p>}
                        </>
                    )
                )}
            </div>
        </div>
    )
}

export { Zones };